import { render, staticRenderFns } from "./NMB.vue?vue&type=template&id=a0c69134&"
import script from "./NMB.vue?vue&type=script&lang=js&"
export * from "./NMB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports